export function getUser() {
    return JSON.parse(localStorage.getItem('raesUser') ?? '{}');
}

export function setUser(user: unknown) {
    localStorage.setItem('raesUser', JSON.stringify(user));
}